module.exports = __webpack_public_path__ + "media/images/flags/16/England-47628022da260f7a62265b949e8fccee.png";